import React from 'react';
import { Link } from 'gatsby';

let Graphic = () => /*#__PURE__*/React.createElement("div", null, "Logo");

const Logo = ({
  logo
}) => {
  if (logo.graphic) {
    Graphic = () => {
      const graphicFile = require("../images/".concat(logo.graphic));

      return graphicFile.default();
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "logo",
    title: logo.siteTitle
  }, /*#__PURE__*/React.createElement(Link, {
    to: logo.link
  }, /*#__PURE__*/React.createElement(Graphic, null)));
};

Logo.displayName = 'Logo';
export default Logo;